import { useState, type FormEvent } from "react";
import { IconLock, IconLogin2 } from "@tabler/icons-react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export function LoginPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (auth.status === "authenticated" && auth.user) {
    return <Navigate to={auth.user.role === "SUPERADMIN" ? "/superadmin" : "/admin"} replace />;
  }

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const user = await auth.login(email, password);
      navigate(user.role === "SUPERADMIN" ? "/superadmin" : "/admin", { replace: true });
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Nie udało się zalogować");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login-page">
      <section className="card login-card" aria-labelledby="login-title">
        <div className="login-mark"><IconLock size={30} aria-hidden="true" /></div>
        <h1 id="login-title">Panel InfoParafia</h1>
        <p className="text-secondary">Zaloguj się jako administrator lub superadministrator.</p>
        <form onSubmit={submit}>
          <label className="form-label" htmlFor="login-email">E-mail</label>
          <input
            id="login-email"
            className="form-control"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          <label className="form-label mt-3" htmlFor="login-password">Hasło</label>
          <input
            id="login-password"
            className="form-control"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          {error ? <div className="alert alert-danger mt-3" role="alert">{error}</div> : null}
          <button className="btn btn-primary w-100 mt-4" disabled={busy} type="submit">
            <IconLogin2 size={18} aria-hidden="true" />
            {busy ? "Logowanie…" : "Zaloguj"}
          </button>
        </form>
      </section>
    </main>
  );
}
